import React from "react";
import LeftArrowIcon from "../../icons/leftArrow";
import RightArrowIcon from "../../icons/rightArrowIcon";
import styles from "./style.module.css";

const MobilePagination = ({
  totalPages,
  limitData,
  selectedPage,
  handlePagination,
}) => {
  return (
    <div className={styles.mobile_pagination}>
      <div className={styles.mobile_pagination_inner}>
        <div className={styles.mobile_pagination_num}>
          {selectedPage}-{limitData} of {totalPages}
        </div>
        <div className={styles.mobile_pagination_btn}>
          <button
            type="button"
            onClick={() => handlePagination(selectedPage - 1)}
            disabled={selectedPage === 1}
          >
            <LeftArrowIcon />
          </button>
          <button
            type="button"
            onClick={() => handlePagination(selectedPage + 1)}
            disabled={selectedPage === totalPages}
          >
            <RightArrowIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobilePagination;
